// Single source of truth for schemaUrl and componentType
// Used by both admin and guest configs
export const CASH_FUND_COMPONENT_SCHEMA_URL = 'https://heygirl.cutestperson.com/assets/public/schemas/CashFundComponent_v2_0_1.json' as const;
export const CASH_FUND_COMPONENT_TYPE = 'CashFundComponent' as const;
export const CASH_FUND_BUTTON_LABEL_MAX_LENGTH = 50 as const;
